/**
 * The draft revision an editor's saves stand on, bound to the design it was read
 * from: a save of one design must never carry another's (each design counts its
 * own), or it is refused as moved — or, worse, accepted on a base it never had.
 */
export type Revision = { layoutId: string; rev?: number }

/** What a save of layoutId may send, or null when the revision held is another design's. */
export function revisionFor(held: Revision | null, layoutId: string): { rev?: number } | null {
  return held && held.layoutId === layoutId ? { rev: held.rev } : null
}

/** The revision after a save of layoutId came back with rev; another design's answer changes nothing. */
export function afterSave(held: Revision | null, layoutId: string, rev: number | undefined): Revision | null {
  if (!held || held.layoutId !== layoutId || rev === undefined) return held
  return { layoutId, rev }
}

/** done's answer, or false once ms have passed without one: a wait that cannot hang. */
export function answeredWithin(done: Promise<boolean>, ms: number): Promise<boolean> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(false), ms)
    done.then(
      (ok) => {
        clearTimeout(timer)
        resolve(ok)
      },
      () => {
        clearTimeout(timer)
        resolve(false)
      },
    )
  })
}
